import { API, authClient } from '../index'

// Get all advisor services 
export const getAllActiveAdvisorServices = () => {
    return authClient().get(`${API}/advisorService/`)
}

export const getAllAdvisorServices = () => {
    return authClient().get(`${API}/advisorService/?getDisabled=true`)
}

// Get advisorService by id
export const getAdvisorServiceById = (id) => {
    return authClient().get(`${API}/advisorService/${id}`)
}

// Create advisorService
export const postAdvisorService = async (advisorService) => {
    return authClient().post(`${API}/advisorService/`, advisorService)
}

// Update text
export const updateAdvisorService = (id, advisorService) => {
    return authClient().put(`${API}/advisorService/${id}`, advisorService)
}

// Change status advisorService
export const changeStatusAdvisorService = async (id, active) => {
    return authClient().put(`${API}/advisorService/change-status/${id}`, { active });
};


// Delete advisorService
export const deleteAdvisorService = (id) => {
    return authClient().delete(`${API}/advisorService/${id}`)
}
